import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderMiniEntity } from '../../domain/entities/OrderMiniEntity'
import type { OrderAdminDto } from '@/backend/market'

export class OrderMiniModel extends OrderMiniEntity {
  constructor(dataDto: OrderAdminDto) {
    super()
    mapEntityProperties<OrderMiniEntity>(this, dataDto, {
      map: {
        userLocationFarAwayFromUserAddress: dataDto.address?.userLocationFarAwayFromUserAddress
      }
    })
  }
}
